export enum Representatives
{
    ServiceNumber = 1,
    ServiceTypeNumber = 5,
    ServiceNumberPrevious = 2,
    UserNumber = 3,
    Diagnostic = 4,
    BaseId = 7,
    CloseNumber = 9,
    NumberOfTravellers = 10,
    NumberOfServicesAlreadyMade = 11,
    NumberOfServicesAvailable = 12,
    Rebill = 15,
    SupervisorCodeAuthKm = 16,
    ServiceStatusForClonedService = 18,
    NumberOfSystem = 19,
​
    // standard
    CarColor = 26,
    PriorityService = 13,
    MobilType = 6,
    PhoneNumber = 21,
    LicencePlate = 22,
    RadioCompany = 27,
    PolicyNumber = 28,
    PolicyStartDate = 30,
    PolicyEndDate = 31,
    IdPost = 32,
    ClientExist = 33,
    NumeProdComp = 35,
    NumeOrgaComp = 36,
    Email = 37,
    StartDateSVC = 40,
    ScheduleDate = 41,
    FinalHourSvc = 43,
    UserId = 76,
    Aux = 89,
    Company = 93,
    ProductNumber = 94,
    CarBrand = 24,
    CarYearModel = 25,
    ClientName = 20,
    CodeVehicle = 38,
    VehicleType = 29,
    CarType = 120,
    CategoryService = 117,
​
    // origin
    Origin_locality = 44,
    Origin_street = 45,
    Origin_numberStreet = 46,
    Origin_latitude = 47,
    Origin_longitude = 48,
    Origin_requestIn = 49,
    Origin_extraInformation = 51,
    Origin_province = 106,
    Origin_country = 133,
​
    // destination
    Destination_locality = 52,
    Destination_street = 53,
    Destination_numberStreet = 54,
    Destination_latitude = 55,
    Destination_longitude = 56,
    Destination_requestIn = 57,
    Destination_ExtraInformation = 59,
    Destination_province = 107,
    Destination_country = 134,
    Destination_tolls = 254,
​
    KmDistance = 72,
    IsSinister = 73,
    UserName = 81,
    OrigenLocationHolder = 111,
    DocumentNumber = 116,
    CarBrandManual = 121,
    CloseReference = 123,
​
    // Travellers
    AutoIncrementTravellers = 128,
    NameTravellers = 129,
    AgeTravellers = 130,
    DocumentNumberTravellers = 131,
    HurtTravellers = 132,
​
    // Json Edit
    NameStatServ = 135,
    NameColo = 136,
    NameDiagEsti = 137,
    NumbDiagReal = 138,
    NameClos = 139,
    NumbDeri = 140,
    NameDeri = 141,
    NumbBaseFact = 142,
    NameBaseFact = 143,
    NameCondIva = 144,
    NumbMovi = 145,
    NameMovi = 146,
    NameRadi = 147,
    TimeTake = 148,
    TimeRequest = 149,
    TimeDeri = 150,
    TimeAcep = 151,
    TimeAsig = 152,
    TimeMoviAcep = 153,
    TimeArrival = 154,
    NumbStatServ = 155,
    AdditionalPhones = 159,
    SimpleLocationOrigin = 157,
    SimpleLocationDestination = 257,
​
    AdditonalPassagers = 197,
    ContentionPassagers = 199,
    CompanionPassengers = 200,
​
    CarBrandDesciption = 252,
    CarModelDesciption = 253,

    Companion = 1000,
    ChildrensInVehicle = 198,
    HasCargo = 227,
    CargoInfo = 229,
    HasDome = 232,
    DomeHigherThanCabin = 233,
    Vehicle_Long_Short = 235,
    Vehicle_Ceiling_Type = 236,

    ExpandFail = 281,
    AddDetail = 282,
    Tires = 284
}
